import {useAppSelector} from '@/hooks';

export function useGetNumberOfAudios(): number {
  const audioItemsHashMap = useAppSelector((state) => {
    return state.posterEditor.posterObject?.audioClips.audioItemsHashMap;
  });

  if (!audioItemsHashMap) {
    return 0;
  }
  return Object.keys(audioItemsHashMap).length;
}
